<template>
  <transition name="upgrademodal">
    <div
      class="modal-mask fixed top-0 left-0 w-full h-screen outline-none fade"
    >
      <div
        class="modal-container w-10/12 mt-12 mb-10 mx-auto rounded-xl shadow-lg z-50 h-2/3 bg-white"
      >
        <div class="h-full overflow-y-auto w-12/12 mx-auto">
          <slot name="body">
            <div class="w-full h-full grid grid-cols-2 space-y-1">
              <div class="bg-indigo-700 h-full rounded-l-xl">
                <img
                  src="@/assets/images/article-lock.png"
                  class="w-1/2 mx-auto mt-10"
                />
              </div>

              <div class="text-center">
                <div class="w-12/12 mt-4 mr-8 text-right">
                  <i
                    class="fas fa-times cursor-pointer mt-0 rounded-2 text-black text-3xl z-50"
                    @click="$emit('close')"
                  ></i>
                </div>


                <div class="mt-6 mx-10 text-left w-9/12">
                  <h2 class="text-4xl font-bold">Trial Expired</h2>
                  <p class="text-base mt-4 font-bold">
                    Unfortunately your free trial period has expired. 
                  </p>

                  <p class="text-base mt-4">
                    Please contact us to upgrade your account, to extend this period or discuss your next steps
                    or notify us directly below.
                  </p>

                  <p class="text-base mt-4">
                    Your account will automatically revert to our <strong>FREE</strong> access with limited features at the end of the term. To find out more about this please don't hesitate to get in touch.

                  </p>

                  <div
                    v-if="!interestComplete"
                    class="flex justify-between text-center grid grid-cols-2 space-x-6 mt-8 w-10/12 text-sm"
                  >
                    <button
                      @click="processUpgrade('Account Upgrade')"
                      class="block bg-action-blue hover:bg-opacity-50 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
                    >
                      Upgrade/Extend Account
                    </button>
                  </div>
                  <p class="bg-green-500 text-white p-3 rounded mt-4 text-base font-bold mt-8" v-else>
                    Thank you for registering your interest. <br />One of our
                    team will be in touch.
                  </p>
                </div>
              </div>
            </div>
          </slot>
          <footer></footer>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { SchoolService } from "@/services/school.service";


export default {
  name: "upgrademodal",
   props: {
    area: { type: String, required: true },
  },
  data() {
    return {
      interestComplete: false,
    };
  },
  methods: {
    processUpgrade(option) {
      let result = "Upgrade Request \nType: " + option + "\nArea: " +this.area;
      let payload = { content: result };
      SchoolService.create("comms/feature-request", payload)
        .then((response) => this.completion())
        .catch((err) => {
          console.log("Reset error " + err);
        });
    },
    completion() {
      this.interestComplete = true
    }
  },
    components: {
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-list li {
  @apply pb-4;
}

.info-list li strong {
  @apply text-purple-700;
}
</style>
